import { messages as portugueseMessages } from "./pt";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as indonesianMessages } from "./id";

const messages = {
	...portugueseMessages,
	...englishMessages,
	...spanishMessages,
	...indonesianMessages,
};

export { messages };
